export default __webpack_public_path__ + "static/media/logo_round_yellow.7b47467c.png";